export const SET_FOCUS_ID = 'SET_FOCUS_ID';
export const RESET_POSITION = 'RESET_POSITION';
export const SET_FIRST_KEY = 'SET_FIRST_KEY';

export function setFirstKey() {
    return {
        type: SET_FIRST_KEY
    }
}

export function resetPosition() {
    return {
        type: RESET_POSITION
    }
}

export function setFocusId(id) {
    return {
        type: SET_FOCUS_ID,
        payload: {id}
    }
}




// WEBPACK FOOTER //
// ./src/common/components/keyboard/actions.js